module.exports = __webpack_public_path__ + "img/Parmin Sedigh.b09d2d7a.jpg";